import { useState, useEffect } from "react";
import {
  DocumentDuplicateIcon,
  CheckIcon,
  XMarkIcon,
} from "@heroicons/react/24/outline";

export function CopyButton({
  text,
  className,
}: {
  text: string;
  className: string;
}) {
  const [isCopied, setIsCopied] = useState<string>("idle");

  useEffect(() => {
    const timeout = setTimeout(() => {
      setIsCopied("idle");
    }, 3000);
    return () => clearTimeout(timeout);
  }, [isCopied]);

  return (
    <button
      onClick={async () => {
        try {
          await navigator.clipboard.writeText(text);
          setIsCopied("success");
        } catch (e) {
          setIsCopied("failure");
        }
      }}
      aria-live="assertive"
      aria-label={isCopied === "success" ? "Copied" : "Copy to clipboard"}
      className="focus:outline-brand"
    >
      {isCopied === "idle" && <DocumentDuplicateIcon className={className} />}
      {isCopied === "success" && (
        <CheckIcon
          className={className + " text-green-500 hover:text-green-500"}
        />
      )}
      {isCopied === "failure" && (
        <XMarkIcon className={className + " text-red-500 hover:text-red-500"} />
      )}
    </button>
  );
}
